import { OperationsServiceAPIs } from '../api/operations-service';

export const api = OperationsServiceAPIs();
